import { atom } from "~/observers/jotai";

import type { PeriodizedSeries } from "../evalutation/types";
import type { AerobicRow, SessionMetadata } from "./types";

export const aerobicMacrocycleAtom = atom<AerobicRow[]>([]);

export const strengthMacrocycleAtom = atom<
	Array<PeriodizedSeries & SessionMetadata>[]
>([]);
